import { render } from "./MenuCaret.vue?vue&type=template&id=c070bb88&scoped=true"
import script from "./MenuCaret.vue?vue&type=script&lang=js"
export * from "./MenuCaret.vue?vue&type=script&lang=js"

import "./MenuCaret.vue?vue&type=style&index=0&id=c070bb88&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c070bb88"]])

export default __exports__